import { connect } from 'react-redux';
import PengisianNilai from '../../../views/Kurikulum/Ulangan/PengisianNilai.view';
import { getStudent } from '../../../states/thunks/student.thunk';


function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}
export default connect(null, mapDispatchToProps)(PengisianNilai);
